<template>
	<v-flex>
		<v-row class="d-flex flex-column mb-4">
			<v-col>
				<main-carousel></main-carousel>
			</v-col>
		</v-row>

		<v-row class="d-flex justify-center align-center mb-12 mx-2">
			<v-col lg="4" md="12" sm="12" class="mb-12">
				<game-info></game-info>
			</v-col>

			<v-col lg="6" md="12" sm="12" class="mb-12">
				<game-review></game-review>
			</v-col>

			<v-col lg="10" md="12" sm="12" class="mb-6">
				<game-related></game-related>
			</v-col>
		</v-row>
		<main-footer></main-footer>
	</v-flex>
</template>

<script>
export default {
	data() {
		return {}
	},
	components: {
		"main-carousel": require("../components/products/casino/carousel").default,
		"game-info": require("../components/products/casino/gameInfo").default,
		"game-review": require("../components/products/casino/gameReview").default,
		"game-related": require("../components/products/casino/gameRelated").default,
		"main-footer": require("../components/common/footer").default,
	},
}
</script>

<style lang="sass" scoped>

</style>
